<template>
    <div class="classroom-cards-management">
        <el-dialog
            :visible.sync="dialog.visible"
            @close="handleCancel()"
            width="30%">
            <div slot="title" class="dialog-title">
                <div class="title-dot"></div>
                {{dialog.title}}
            </div>

            <el-form :model="dialog.content" ref="formContent" label-width="112px">
                <el-form-item label="卡片名称: " prop="cardName">
                    <el-input v-model="dialog.content.cardName" placeholder="请输入卡片名称"></el-input>
                </el-form-item>
                <el-form-item label="所属门店: " prop="storeListId">
                    <el-select v-model="dialog.content.storeListId" :multiple="true" placeholder="请选择门店">
                        <el-option 
                            v-for="store in storeList" 
                            :key="store.value" 
                            :label="store.name"
                            :value="store.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卡片描述: " prop="description">
                    <el-input v-model="dialog.content.description" placeholder="请输入卡片描述"></el-input>
                </el-form-item>
                <el-form-item label="卡片有效期: " prop="serviceLife">
                    <el-input v-model="dialog.content.serviceLife" placeholder="请输入卡片有效期"></el-input>
                </el-form-item>
                <el-form-item label="卡片时长: " prop="times">
                    <el-input v-model="dialog.content.times" placeholder="请输入卡片时长"></el-input>
                </el-form-item>
                <el-form-item label="卡片等级: " prop="cardLevel">
                    <el-input v-model="dialog.content.cardLevel" placeholder="请输入卡片等级"></el-input>
                </el-form-item>
                <el-form-item label="原始金额: " prop="originalPrice">
                    <el-input v-model="dialog.content.originalPrice" placeholder="请输入原始金额"></el-input>
                </el-form-item>
                <el-form-item label="折后金额: " prop="currentPrice">
                    <el-input v-model="dialog.content.currentPrice" placeholder="请输入折后金额"></el-input>
                </el-form-item>
                <el-form-item label="次卡截止时间: " prop="endTime">
                    <el-date-picker
                        v-model="dialog.content.endTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="请选择时间">
                    </el-date-picker>
                </el-form-item>
                
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="cancel"  size="small" @click="handleCancel()">取消</el-button>
                <el-button type="primary" size="small" @click="submit()">确定</el-button>
            </span>
        </el-dialog>
        <div class="el-card-title">
            <span>教室卡列表</span>
            <div :style="{ display: 'flex' }">
                <el-tooltip effect="dark" content="新增教室卡" placement="top">
                    <el-button type="text" @click="handleStoreInsert">
                        <i class="mdi mdi-24px mdi-plus"></i>
                    </el-button>
                </el-tooltip>
            </div>
        </div>
        <custom-table :table="tableData" :options="{
            maxHeight: 640
        }">
            <template slot="operation" slot-scope="item">
                <el-button type="text" size="small" @click="handleCardEdit(item.data.row)">编辑</el-button>
            </template>
        </custom-table>
    </div>
</template>

<script>
import { ClassroomCardsManagementApi } from '../http/classroomCardsManagement/classroomCardsManagement';
import { CommonApi } from '../http/common';
import CustomTable from '../components/customTable.vue';
export default {
    name: "classroom-cards-management",
    components: {
        CustomTable
    },
    data(){
        return {
            tableData: {
                data: [],
                columns: [],
                tableLoading: false
            },
            dialog: {
                title: "",
                visible: false,
                type: "",
                content: {
                    numberCardId: "",
                    storeListId: [],
                    cardName: "",
                    serviceLife: "",
                    description: "",
                    times: "",
                    cardLevel: "",
                    originalPrice: "",
                    currentPrice: "",
                    endTime: ""
                }
            },
            storeList: []
        }
    },
    mounted(){
        this.getClassroomCardsList();
        this.getStoreList();
    },
    methods: {
        getStoreList(){
            CommonApi.getStoreSelectorList().then(res => {
                this.storeList = res;
            })
        },
        getClassroomCardsList(){
            this.tableData.tableLoading = true;
            ClassroomCardsManagementApi.getClassroomCardsList().then(res => {
                this.tableData.tableLoading = false;
                Object.assign(this.tableData, res);
            })
        },
        handleCancel(){
            this.dialog.visible = false;
            this.dialog.content = {
                storeListId: [],
                cardName: "",
                serviceLife: "",
                description: "",
                times: "",
                cardLevel: "",
                originalPrice: "",
                currentPrice: "",
                endTime: "",
                numberCardId: ""
            }
        },
        handleStoreInsert(){
            this.dialog.visible = true;
            this.dialog.title = "新增教室卡";
            this.dialog.type = 'insert';
        },
        handleCardEdit(row){
            this.dialog.visible = true;
            this.dialog.title = "编辑教室卡";
            this.dialog.type = 'edit';
            for(let key in this.dialog.content){
                this.dialog.content[key] = row[key];
            }
            this.dialog.content.storeListId = row.storeListId.split(',')
        },
        submit(){
            if(this.dialog.content.storeListId.length === this.storeList.length)
                this.dialog.content.storeRange = 1;
            else
                this.dialog.content.storeRange = 0;

            if(this.dialog.content.storeListId.length > 1)
                this.dialog.content.storeListId = this.dialog.content.storeListId.join(',');
            else
                this.dialog.content.storeListId = this.dialog.content.storeListId[0];
            if(this.dialog.type === 'insert'){
                ClassroomCardsManagementApi.insertClassroomCard(this.dialog.content).then(res => {
                    if(res.data.status === 200){
                        Object.assign(this.tableData, res);
                        this.$notify.success({ title: '新增教室卡成功' });
                        this.handleCancel();
                        this.getClassroomCardsList();
                    } else {
                        this.$notify.error({title: res.data.message});
                    }
                })
            } else{
                ClassroomCardsManagementApi.updateClassroomCard(this.dialog.content).then(res => {
                    if(res.data.status === 200){
                        Object.assign(this.tableData, res);
                        this.$notify.success({ title: '编辑教室卡成功' });
                        this.handleCancel();
                        this.getClassroomCardsList();
                    } else {
                        this.$notify.error({title: res.data.message});
                    }
                })
            }
        }
    }
}
</script>

<style lang="less">
div.classroom-cards-management{
}
</style>